"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNavConfig = exports.NavConfigProvider = exports.NavConfigConsumer = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const contextDefault = {
  isRegionalSettingsShown: true,
  isHelpShown: true,
  isSignInShown: true,
  isLogoShown: true,
  isSideNavShown: true,
  isFareLocksLinkShown: true,
  areHeaderLinksShown: true,
  isReferAFriendShown: true
};
const context = /*#__PURE__*/React.createContext(contextDefault);
context.displayName = "NavConfigContext";
const {
  Consumer: NavConfigConsumer,
  Provider
} = context;
exports.NavConfigConsumer = NavConfigConsumer;
const NavConfigProvider = _ref => {
  let {
    value,
    children
  } = _ref;
  const shownFeatures = React.useMemo(() => {
    function visible(input) {
      if (typeof value.hide === "string") {
        return input !== value.hide;
      }
      return !value.hide.includes(input);
    }
    return {
      isRegionalSettingsShown: visible("regionalSettings") && visible("currencies") && visible("languages"),
      isHelpShown: visible("help"),
      isSignInShown: visible("signIn") && visible("mmb"),
      isLogoShown: visible("logo"),
      isSideNavShown: visible("sideNav"),
      isFareLocksLinkShown: visible("fareLocks"),
      areHeaderLinksShown: visible("headerLinks"),
      isReferAFriendShown: visible("referAFriend")
    };
  }, [value.hide]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: {
      ...shownFeatures,
      onSaveRegionalSettings: value.onSaveRegionalSettings
    },
    children: children
  });
};
exports.NavConfigProvider = NavConfigProvider;
const useNavConfig = () => {
  const ctx = React.useContext(context);
  if (ctx == null) {
    throw new Error("No context found for NavConfigContext, did you forget the NavConfigProvider?");
  }
  return ctx;
};
exports.useNavConfig = useNavConfig;